import * as React from 'react';

import { Spinner } from '../assets/Spinner';
import { NotFound } from '../component/NotFound';
import { OrderDetail } from '../component/OrderDetail';
import { OrderFulfillments } from '../component/OrderFulfillments';
import { PaymentDetail } from '../component/PaymentDetail';
import { Products } from '../component/Products';
import { ShippingDetail } from '../component/ShippingDetail';
import { useGetCustomer } from '../hooks/getCustomer';
import { useCustomParams } from '../hooks/useCustomParams';
import { useGetDisputeStatus } from '../hooks/useGetDisputeStatus';
import { generateFullName, getCountryFlag, getOrder } from '../utils';

export const OrderDetailFull = () => {
  const { customerId, orderId } = useCustomParams();
  const { customer, isLoading, isError, refreshCustomer } = useGetCustomer(customerId);
  const { disputeStatus, isLoading: isLoadingDisputeStatus } = useGetDisputeStatus(orderId);

  if (isLoading || !orderId) return <Spinner />;

  if (isError) return <NotFound />;

  let order = null;
  if (!isLoading) {
    order = getOrder(customer.orders, orderId);
  }

  if (!order) {
    return <NotFound />;
  }

  const isPreviewOrder = order.status === 'PREVIEW';

  return (
    <div className="h-[calc(100vh-77px)] bg-slate50 p-8">
      <div className="w-full pr-4">
        <h1>
          <b>Customer:</b>{' '}
          {`${getCountryFlag(customer.default_country)} ${generateFullName(
            customer.first_name,
            customer.last_name
          )} (${customer.email})`}
          <br />
          <b>Order:</b> {order.id}
        </h1>
      </div>
      <div className="flex pt-3 space-x-2">
        <div className="flex-[0.9]">
          <OrderDetail
            customer={customer}
            order={order}
            refreshCustomer={refreshCustomer}
            disputeStatus={disputeStatus}
            isLoadingDisputeStatus={isLoadingDisputeStatus}
          />
        </div>
        <div className="flex-[1]">
          <ShippingDetail customer={customer} order={order} refreshCustomer={refreshCustomer} />
        </div>
        <div className="flex-[0.9]">
          <PaymentDetail
            order={order}
            disputeStatus={disputeStatus}
            isLoadingDisputeStatus={isLoadingDisputeStatus}
          />
        </div>
      </div>

      <div className="w-full">
        {isPreviewOrder && (
          <Products
            customer={customer}
            refreshCustomer={refreshCustomer}
            products={order.products}
            order={order}
          />
        )}
        {!isPreviewOrder && (
          <OrderFulfillments customer={customer} order={order} refreshCustomer={refreshCustomer} />
        )}
      </div>
    </div>
  );
};
